export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        readonly: {
            type: Boolean,
        },
        error: {
            type: Boolean,
        },
        value: {
            type: String,
        },
        hint: {
            type: String,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    data() {
        return {
            local: this.value,
        }
    },
    methods: {
        update(value) {
            this.$emit('input', value)
        },
    },
}
